.preference-options-container {
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.preference-option {
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.disabled-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--off-white);
    opacity: 0.6;
}

.divider {
    width: 45px;
    margin: 0 14px;
    border: 0.6px solid #7a7370;
}
